import { CONSTANTS__client } from '@/constants/CONSTANTS__client';
import i18n_page_settings_workspace from '@/locales/keys/i18n_page_settings_workspace.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { useTranslation } from 'react-i18next';
import { TabSettingsWorkspaceWrapper } from '../_base/TabSettingsWorkspaceWrapper';
import { ESettingsWorkspaceTab } from '../ESettingsWorkspaceTab';
import { EFeaturesCategory } from './table_base/EFeaturesCategory';
import { WSFeaturesTable } from './table_features/WSFeaturesTable';

export function TabSettingsWorkspaceFeaturesAccess() {
  const workspace_features_categories = [
    EFeaturesCategory.IMAGE,
    EFeaturesCategory.DIFFUSION_MODELS,
    EFeaturesCategory.SEARCH,
    EFeaturesCategory.GENERATION,
    EFeaturesCategory.USER_TASK,
    EFeaturesCategory.COLLECTION,
  ];
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_SETTINGS_WORKSPACE);

  /*
   * HTML
   */

  return (
    <TabSettingsWorkspaceWrapper type={ESettingsWorkspaceTab.FEATURES_ACCESS} required_owner_access>
      <div
        className="flex flex-col justify-start items-start mt-2 gap-3  text-page-foreground overflow-auto"
        style={{ height: `calc(100vh - ${CONSTANTS__client.TOPBAR_HEIGHT}px` }}
      >
        <span className="text-xl">{t(i18n_page_settings_workspace.tabs.features_access.sub_title)}</span>

        <WSFeaturesTable category={EFeaturesCategory.BULK_ACTIONS} />

        {workspace_features_categories.map((item, index) => (
          <WSFeaturesTable category={item} key={`${item}_${index}`} />
        ))}
      </div>
    </TabSettingsWorkspaceWrapper>
  );
}
